export const s3Bucket = process.env.REACT_APP_S3_BUCKET || "fabric-advertiser-portal";
const isDev = process.env.NODE_ENV === "development";
export const serverURL = isDev ? "http://127.0.0.1:5000/" : process.env.REACT_APP_API_URL;
// export const serverURL =
//   "https://vg2twm4crk.execute-api.us-east-1.amazonaws.com/test/";
export const plaidPublicKey = "c0d3131598390858fd0b340f64c67f";
